export default "__VITE_ASSET__Dt2293qG__"